import {createHashRouter} from "react-router-dom";
import Home from "../pages/home/home";
import Dashboard from "../pages/dashboard/dashboard";
import Trips from "../pages/trips/trips";
import Drivers from "../pages/drivers/drivers";
import DriverDetails from "../pages/driverDetails/driverDetails";
import TripsDetails from "../pages/tripsDetails/tripsDetails";
import LiveTrack from "../pages/liveTrack/liveTrack";
import LiveTrackDetails from "../pages/liveTrackDetails/liveTrackDetails";
import VideoTelematics from "../pages/videoTelematics/videoTelematics";
import Vehicles from "../pages/vehicles/vehicles";
import Login from "../pages/login/login";
import RouterProtector from "./routerProtector";
import TelematicsCriticalAlerts
    from "../components/videoTelematicsComponent/telematicsCriticalAlerts/telematicsCriticalAlerts";
import TelematicsOnDemandVideos
    from "../components/videoTelematicsComponent/telematicsOnDemandVideos/telematicsOnDemandVideos";


const router = createHashRouter([
    {
        path: '',
        element: <Home/>,
        children: [
            {
                path: '',
                element: <Login />
            },
            {
                path: '',
                loader: RouterProtector,
                children: [
                    {
                        path: 'dashboard',
                        element: <Dashboard />
                    },
                    {
                        path: 'trips',
                        element: <Trips />
                    },
                    {
                        path: 'trips/:id',
                        element: <TripsDetails />
                    },
                    {
                        path: 'drivers',
                        element: <Drivers />
                    },
                    {
                        path: 'vehicles',
                        element: <Vehicles />
                    },
                    {
                        path: 'drivers/:id',
                        element: <DriverDetails/>
                    },
                    {
                        path: 'liveTrack',
                        element: <LiveTrack/>
                    },
                    {
                        path: 'liveTrack/:id',
                        element: <LiveTrackDetails/>
                    },
                    {
                        path: 'videoTelematics',
                        element: <VideoTelematics/>,
                        children: [
                            {
                                path: 'criticalAlerts',
                                element: <TelematicsCriticalAlerts/>
                            },
                            {
                                path: 'onDemandVideos',
                                element: <TelematicsOnDemandVideos/>
                            }
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '',
        element: <LiveTrack/>
    },
])

export default router;
